import { trackInteraction } from 'client/javascript/analytics';
import { showElements, hideElements } from 'client/javascript/util/dom_utils';
import appendQuery from 'append-query';
import User, { USER_STORAGE_KEY_MAP } from 'shared/storage/user';
import { getStartDateFilter, formatStartDateForIQS } from 'shared/util/date';
import {
  OPEN_FORM_BTN_INTERACTION_LABEL,
  CLOSE_FORM_BTN_INTERACTION_LABEL
} from 'client/javascript/pages/building/form';
import { DEFAULT_CAPACITY } from 'client/self_serve/components/FilterChips/FilterChips';
import { SPECIAL_CAPACITIES_MAP } from 'shared/util/search_constants';
import { varsFromServer } from 'client/javascript/client_side_injection_vars';
import initFlatpickr from 'client/javascript/filters/date_picker';
import { ISODateToLocalizedShortDate } from 'client/javascript/util/locale';
import { __ } from 'client/javascript/messages';
import NumberStepper from '../../number_stepper';

export default class SelfServe {
  constructor() {
    this.selfServeBtn = document.getElementById('self-serve-btn');
    this.mobileSelfServeBtn = document.getElementById('self-serve-button-mobile');
    this.getInTouchBtn = document.getElementById('get-in-touch-btn');
    this.selfServeWrapper = document.querySelector('.self-serve-wrapper');
  }

  setupSelfServe() {
    if (this.selfServeBtn) {
      this.updateReserveButtons();
    }
    if (this.getInTouchBtn) {
      // initialize number stepper and date picker for second lead form
      // eslint-disable-next-line no-new
      new NumberStepper(document.querySelector('.get-in-touch-form .number-stepper'));
      SelfServe.initializeDatePicker();
    }
    this.addFormEvents();
  }

  updateReserveButtons() {
    // this gets called when search filters are selected so we return early if that happens
    if (this.getInTouchBtn) return;

    const { building = {} } = varsFromServer;
    const storedCapacity = User.getValue(USER_STORAGE_KEY_MAP.capacity);
    const capacity = SPECIAL_CAPACITIES_MAP[storedCapacity] || storedCapacity || DEFAULT_CAPACITY;
    const startDate = formatStartDateForIQS(getStartDateFilter());

    [this.selfServeBtn, this.mobileSelfServeBtn].forEach(link => {
      const { href } = link;
      const buildingIdQuery = !href.includes(building.slug) && { slug: building.slug };
      link.setAttribute('href', appendQuery(`${href}`, { ...buildingIdQuery, ...{ capacity, start_date: startDate } }));

      link.addEventListener('click', () => {
        trackInteraction({
          label: 'Click to Self Serve'
        });
      });
    });
  }

  addFormEvents() {
    document.querySelectorAll('.building-lead-form-cta').forEach(element => {
      element.addEventListener('click', e => {
        e.preventDefault();
        trackInteraction({
          label: OPEN_FORM_BTN_INTERACTION_LABEL
        });
        hideElements(this.selfServeWrapper);
        const node = e.target.nodeName !== 'BUTTON' && e.target.nodeName !== 'A' ? e.target.parentNode : e.target;
        document.querySelector(`.${node.dataset.type}`).classList.remove('hidden');
      });
    });

    document.querySelectorAll('.close-form').forEach(closeBtn => {
      closeBtn.addEventListener('click', e => {
        e.preventDefault();
        trackInteraction({
          label: CLOSE_FORM_BTN_INTERACTION_LABEL
        });
        showElements(this.selfServeWrapper);
        document.querySelectorAll('.building-lead-form').forEach(element => element.classList.add('hidden'));
      });
    });
  }

  static initializeDatePicker() {
    const moveInDateBtn = document.querySelector('.get-in-touch-form #moveInDateBtn');
    const moveInDateInput = document.querySelector('.get-in-touch-form #moveInDate');
    const moveInDateWrapper = document.querySelector(' .get-in-touch-form #moveInDateWrapper');

    const savedDate = User.getValue(USER_STORAGE_KEY_MAP.startDateFilter);
    if (savedDate) {
      moveInDateInput.value = savedDate;
      moveInDateBtn.textContent = ISODateToLocalizedShortDate(savedDate);
    }

    initFlatpickr({
      input: moveInDateInput,
      onChange: dates => {
        let formattedDate;
        if (dates.length) {
          formattedDate = ISODateToLocalizedShortDate(dates[0], false);
          User.saveValue(USER_STORAGE_KEY_MAP.startDateFilter, moveInDateInput.value);
        } else {
          formattedDate = __('moveInDateNotSelected');
          User.clearValue(USER_STORAGE_KEY_MAP.startDateFilter);
        }

        moveInDateBtn.textContent = formattedDate;
      },
      appendTo: moveInDateWrapper
    }).then(datePicker => {
      moveInDateBtn.addEventListener('click', datePicker.toggle);

      const moveInDateClear = document.getElementById('search-clear__date');

      moveInDateClear.addEventListener('click', () => {
        datePicker.clear();
        datePicker.close();
      });

      showElements(moveInDateClear);

      // simulate ray select component
      moveInDateBtn.addEventListener('focus', () => moveInDateWrapper.classList.add('ray-select--active'));
      moveInDateBtn.addEventListener('blur', () => moveInDateWrapper.classList.remove('ray-select--active'));
    });
  }
}
